import { render, staticRenderFns } from "./CallWaiter.vue?vue&type=template&id=8c8e5516&scoped=true&"
import script from "./CallWaiter.vue?vue&type=script&lang=ts&"
export * from "./CallWaiter.vue?vue&type=script&lang=ts&"
import style0 from "./CallWaiter.vue?vue&type=style&index=0&id=8c8e5516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8e5516",
  null
  
)

export default component.exports